export default "__VITE_ASSET__D8iR2V2W__"